@file:Suppress("TooGenericExceptionThrown")

package com.klantenstop.web.data.repos

import com.klantenstop.web.data.NetworkingConfig
import com.klantenstop.web.data.deleteRequest
import com.klantenstop.web.data.getRequest
import com.klantenstop.web.data.models.NetworkResponse
import com.klantenstop.web.data.models.domain.CuratedCity
import com.klantenstop.web.data.models.domain.toCuratedCity
import com.klantenstop.web.data.models.dto.requests.curatedcity.InsertCuratedCity
import com.klantenstop.web.data.models.dto.requests.curatedcity.UpdateCuratedCity
import com.klantenstop.web.data.models.dto.responses.CuratedCityDto
import com.klantenstop.web.data.models.dto.responses.ErrorResponse
import com.klantenstop.web.data.postRequest
import com.klantenstop.web.data.putRequest

object CuratedCityRepo {
    private val curatedCityUrl = "${NetworkingConfig.baseUrl}/api/v1/curated-cities"

    suspend fun getCuratedCities(): List<CuratedCity> {
        val response: NetworkResponse<List<CuratedCityDto>, ErrorResponse> = getRequest(curatedCityUrl, bypassCache = true)

        return when (response) {
            is NetworkResponse.Success -> response.body.map { it.toCuratedCity() }
            is NetworkResponse.ServerError -> {
                val errorMessage = response.body?.errorDescription ?: response.body?.error ?: "Server fout bij het ophalen van steden"
                throw Exception(errorMessage)
            }

            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout: controleer je internetverbinding")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij het ophalen van steden")
        }
    }

    suspend fun getCuratedCityById(id: String): CuratedCity {
        val response: NetworkResponse<CuratedCityDto, ErrorResponse> = getRequest("$curatedCityUrl/$id", bypassCache = true)

        return when (response) {
            is NetworkResponse.Success -> response.body.toCuratedCity()
            is NetworkResponse.ServerError -> {
                val errorMessage = response.body?.errorDescription ?: response.body?.error ?: "Server fout bij het ophalen van stad"
                throw Exception(errorMessage)
            }

            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout: controleer je internetverbinding")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij het ophalen van stad")
        }
    }

    suspend fun insertCuratedCity(curatedCity: InsertCuratedCity): CuratedCity {
        val response: NetworkResponse<CuratedCityDto, ErrorResponse> = postRequest(resource = curatedCityUrl, body = curatedCity)

        return when (response) {
            is NetworkResponse.Success -> response.body.toCuratedCity()
            is NetworkResponse.ServerError -> {
                val errorMessage = response.body?.errorDescription ?: response.body?.error ?: "Server fout bij het aanmaken van stad"
                throw Exception(errorMessage)
            }

            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout: controleer je internetverbinding")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij het aanmaken van stad")
        }
    }

    suspend fun updateCuratedCity(id: String, update: UpdateCuratedCity): CuratedCity {
        val response: NetworkResponse<CuratedCityDto, ErrorResponse> = putRequest(resource = "$curatedCityUrl/$id", body = update)

        return when (response) {
            is NetworkResponse.Success -> response.body.toCuratedCity()
            is NetworkResponse.ServerError -> {
                val errorMessage = response.body?.errorDescription ?: response.body?.error ?: "Server fout bij het bijwerken van stad"
                throw Exception(errorMessage)
            }

            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout: controleer je internetverbinding")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij het bijwerken van stad")
        }
    }

    suspend fun deleteCuratedCity(id: String) {
        val response: NetworkResponse<Unit, ErrorResponse> = deleteRequest("$curatedCityUrl/$id")

        when (response) {
            is NetworkResponse.Success -> Unit
            is NetworkResponse.ServerError -> {
                val errorMessage = response.body?.errorDescription ?: response.body?.error ?: "Server fout bij het verwijderen van stad"
                throw Exception(errorMessage)
            }

            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout: controleer je internetverbinding")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij het verwijderen van stad")
        }
    }
}
